import React, { useMemo } from "react";
//
import { Button, FlexDiv, SVGSprite } from "../../../Atoms";
import { Dropdown, PhoneInput, TextInput } from "../../FormInputs";
//
import SelectPackage from "./SelectPackage";
import SelectStartDateModal from "./Modal/SelectStartDate";
//
import Typography from "../../../../foundation/Typography/V2";
import theme from "../../../../foundation/Theme";
//
import {
  FormTitleContainer,
  StyledTitle,
  StyledSubtitle,
  Label,
  NameEmailWrapper,
  StyledFormFieldBox,
} from "./style";
import {
  ArrowRight,
  SecondaryCTA,
  Span,
} from "../../../Molecules/EnrollNowButton/style";
//
function FormInput({
  isLoading,
  success,
  //
  handleChange = () => {},
  handleSelectChange = () => {},
  handleInputBlur = () => {},
  onSubmitButtonClick = () => {},
  //
  title,
  subtitle,
  //
  showNameField,
  namePlaceHolder = "Enter Name",
  name,
  nameError,
  //
  showEmailField,
  emailPlaceholder = "Your Email",
  email,
  emailError,
  //
  showPhoneField,
  mobile,
  mobilePlaceholder = "Your Phone",
  mobileError,
  countryCode,
  countryCodeError,
  //
  showGoalField,
  goalFieldLabel = "What is your health goal?",
  goalPlaceholder = "Select Goal",
  goal,
  goalError,
  goalOptions = [],
  gtmIdHealthGoal,
  //
  showPackageField,
  packageFieldLabel = "Choose a package duration",
  selectedPackageDuration,
  selectedPackageDurationError,
  packageOptions,
  gtmIdPackages,
  gtmIdSinglePackage,
  //
  showStartDateField,
  startDateLabel = "Want to start at a later date?",
  startDate,
  setStartDate,
  openStartDateModal,
  setOpenStartDateModal,
  //
  showPrimaryCTA,
  primaryCTAText = "Enroll Now",
  isPrimaryCTAWithPrice,
  gtmIdPrimaryCTA,
  //
  showRequestCallback,
  secondaryCTAText = "Need more info? Request Callback",
  //
  showTermsAndConditions,
  //
  defaultPackage,
  isPrimaryCTAWithCallback,
}) {
  const Title = title && (
    <StyledTitle variant="heading4" mb="8px">
      {title}
    </StyledTitle>
  );

  const Subtitle = subtitle && (
    <StyledSubtitle variant="label1" fontFamily="var(--man-700)" mb="24px">
      {subtitle}
    </StyledSubtitle>
  );

  const NameField = (
    <TextInput
      placeholder={namePlaceHolder}
      name="name"
      icon="icon-user-face-2"
      value={name}
      onChange={handleChange}
      onBlur={handleInputBlur}
      error={nameError}
      required
      inputPadding="6px 16px 6px 32px"
      inputMarginBottom="40px"
    />
  );

  const EmailField = (
    <TextInput
      placeholder={emailPlaceholder}
      name="email"
      type="email"
      icon="icon-EnvelopeSimple"
      value={email}
      onChange={handleChange}
      onBlur={handleInputBlur}
      error={emailError}
      required
      inputPadding="6px 16px 6px 32px"
      inputMarginBottom="40px"
    />
  );

  const PhoneField = (
    <PhoneInput
      placeholder={mobilePlaceholder}
      value={mobile}
      onChange={handleChange}
      handleSelectChange={handleSelectChange}
      onBlur={handleInputBlur}
      error={mobileError}
      countryCode={countryCode}
      required
      inputPadding="6px 16px 6px 100px"
      inputMarginBottom="40px"
    />
  );

  const GoalField = goalOptions.length > 0 && (
    <FlexDiv flexDirection={"column"} id={gtmIdHealthGoal}>
      <Label variant="paragraph3">{goalFieldLabel}</Label>
      <Dropdown
        placeholder={goalPlaceholder}
        name="goal"
        options={goalOptions}
        value={goalOptions?.find((option) => option.slug === goal) || null}
        onChange={(value) => handleSelectChange("goal", value.slug)}
        onBlur={handleInputBlur}
        error={goalError}
        minHeight="40px"
        inputMarginBottom="32px"
      />
    </FlexDiv>
  );

  const PackagesField = packageOptions?.length > 0 && (
    <FlexDiv flexDirection={"column"}>
      <Label variant="paragraph3">{packageFieldLabel}</Label>

      <SelectPackage
        packageOptions={packageOptions}
        selectedPackageDuration={selectedPackageDuration}
        selectedPackageDurationError={selectedPackageDurationError}
        gtmIdPackages={gtmIdPackages}
        gtmIdSinglePackage={gtmIdSinglePackage}
        setSelectedPackage={(value) => {
          handleSelectChange("selectedPackageDuration", value);
          handleInputBlur({
            target: {
              name: "selectedPackageDuration",
              value,
            },
          });
        }}
      />
    </FlexDiv>
  );

  const formatPackageStartDate = useMemo(() => {
    const _startDate = new Date(startDate);
    const formattedStartDate = `${_startDate.toLocaleString("default", {
      day: "2-digit",
    })} ${_startDate.toLocaleString("default", {
      month: "long",
    })} ${_startDate.toLocaleString("default", { year: "numeric" })}`;

    return formattedStartDate;
  }, [startDate]);

  const StartDateField = (
    <>
      {!startDate ? (
        <Typography variant="label4" flex={1} mb="24px">
          {startDateLabel} Click{" "}
          <Typography
            variant="link2"
            fontSize={["10px", "10px", "12px"]}
            lineHeight={["16px", "16px", "16px"]}
            target="_blank"
            style={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => setOpenStartDateModal(true)}
          >
            here
          </Typography>
          .
        </Typography>
      ) : (
        <Typography variant="label4" flex={1} mb="24px">
          Your Package Start Date: {formatPackageStartDate}{" "}
          <Button
            variant="link"
            onClick={() => setOpenStartDateModal(true)}
            style={{ padding: "8px" }}
          >
            <SVGSprite icon="icon-edit-pen" height="12px" width="12px" />
          </Button>
        </Typography>
      )}
      {openStartDateModal && (
        <SelectStartDateModal
          onClose={() => setOpenStartDateModal(false)}
          startDate={startDate}
          setStartDate={setStartDate}
        />
      )}
    </>
  );

  const pack = packageOptions?.find(
    (p) =>
      p.packageSlug === selectedPackageDuration ||
      p.packageSlug === defaultPackage
  );

  const PrimaryCTA = (
    <SecondaryCTA
      variant="primary1"
      fontSize={["14px", "15px", "16px"]}
      fontFamily={"var(--man-700)"}
      bgColor={theme?.colorsV2?.shyft?.purple_text}
      hoverColor={theme?.colorsV2?.shyft?.purple_text}
      TextColor={theme.colorsV2.primary.shade_25}
      id={gtmIdPrimaryCTA}
      onClick={(e) => onSubmitButtonClick(e, isPrimaryCTAWithCallback)}
      disabled={isLoading}
      isLoading={isLoading}
    >
      {primaryCTAText}
      {isPrimaryCTAWithPrice &&
        `${pack?.priceConstant} ${pack?.discountedPrice}`}
      <Span variant="span">
        <ArrowRight
          icon="icon-arrow-right"
          color={theme?.colorsV2?.shyft?.purple}
        />
      </Span>
    </SecondaryCTA>
  );

  const RequestCallback = !isPrimaryCTAWithCallback && (
    <FlexDiv mt="20px" pl="15px">
      <Typography
        style={{
          cursor: "pointer",
          textDecoration: "underline",
          fontSize: "16px",
        }}
        // flex={1}
        link1Color={theme.colors.gray_50}
        variant={"link1"}
        onClick={(e) => {
          e.preventDefault();
          onSubmitButtonClick(e, true);
        }}
        fontFamily={"var(--man-700)"}
      >
        {secondaryCTAText}
      </Typography>
    </FlexDiv>
  );

  const TermsAndConditions = (
    <Typography variant="label4" flex={1} mt="24px">
      Note: By moving forward you accept our medical waiver and disclaimer
      policy mentioned{" "}
      <Typography
        variant="link2"
        href="https://www.betheshyft.com/medical-waiver-disclaimer/"
        fontSize={["10px", "10px", "12px"]}
        lineHeight={["16px", "16px", "16px"]}
        target="_blank"
        style={{ textDecoration: "underline", cursor: "pointer" }}
      >
        here
      </Typography>{" "}
      , and term & conditions mentioned{" "}
      <Typography
        variant="link2"
        href="https://www.betheshyft.com/terms-condition/"
        fontSize={["10px", "10px", "12px"]}
        lineHeight={["16px", "16px", "16px"]}
        target="_blank"
        style={{ textDecoration: "underline", cursor: "pointer" }}
      >
        here
      </Typography>
      .
    </Typography>
  );

  return (
    <>
      <FormTitleContainer>
        {Title}
        {Subtitle}
      </FormTitleContainer>
      <StyledFormFieldBox isFormSubmitted={success}>
        <NameEmailWrapper>
          {showNameField && NameField}
          {showEmailField && EmailField}
        </NameEmailWrapper>
        {showPhoneField && PhoneField}
        {showGoalField && GoalField}
        {showPackageField && PackagesField}
        {showStartDateField && StartDateField}
        {showPrimaryCTA && PrimaryCTA}
        {showRequestCallback && RequestCallback}
        {showTermsAndConditions && TermsAndConditions}
      </StyledFormFieldBox>
    </>
  );
}

export default FormInput;
